import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import DOMPurify from 'dompurify';
import { translatedMessage } from '../../service/LanguageService';
import { CompetitionService } from '../../service/CompetitionService';
import GeneralUtils from '../../utilities/GeneralUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EnumService from '../../service/EnumService';
import CompetitionUtils from '../../utilities/CompetitionUtils';
import CompetitionEditDialog from '../../pages/competition/CompetitionEditDialog';
import SecurityService from '../../service/SecurityService';

const CompetitionNationalViewComponent = (props) => {
    const [competition, setCompetition] = useState(null);
    const [editDialogVisible, setEditDialogVisible] = useState(false);
    const [competitionStatuses, setCompetitionStatuses] = useState([]);
    // const [competitionTypes, setCompetitionTypes] = useState([]);
    const [hasEditPermission, setHasEditPermission] = useState(false);

    const toast = useRef(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    const { competitionIdParam } = useParams();

    useEffect(() => {
        const getCompetitionStatuses = async () => {
            setCompetitionStatuses(await EnumService.getEnumByNameAndParam('CompetitionStatus', "NATIONAL_DEBUTANT"));
        };

        // const getCompetitionTypes = async () => {
        //     setCompetitionTypes(await EnumService.getEnumByName('CompetitionType'));
        // };

        const checkEditPermission = async () => {
            setHasEditPermission(await SecurityService.check('CAN_EDIT_JOB_COMPETITION', competitionIdParam));
        };

        const getCompetition = async () => {
            // console.log(props?.competition);
            setCompetition(props?.competition);

            await checkEditPermission()
        };

        getCompetitionStatuses();
        // getCompetitionTypes();
        getCompetition();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [competitionService, competitionIdParam]);

    const afterSave = (savedCompetition, isNew, success, error) => {
        if(success) {
            setCompetition(savedCompetition)
            if (typeof props.refresh === 'function') {
                props.refresh(savedCompetition);
            }
            toast.current.show({ severity: 'success', summary: translatedMessage('generic.save.success') });
        } else {
            toast.current.show({ severity: 'error', summary: translatedMessage(error), life: 5000 });
        }

    };

    return (
        <>
            <Toast ref={toast} />
            <div className='w-full grid pcn-data-view-panel'>
                <div className='col-12'>
                    <h5 className='mb-1 font-weight-normal'>{translatedMessage("competition.details")}</h5>
                    <Button
                        className="pcn-button-slim p-button-text"
                        onClick={() => setEditDialogVisible(true)}
                        visible={hasEditPermission}
                    >
                        <div className='flex align-items-center'>
                            <FontAwesomeIcon icon='fa-solid fa-pencil' className="mr-1 " />
                            <span>{translatedMessage('generic.edit')}</span>
                        </div>
                    </Button>
                </div>
                <div className='col-12 md:col-6'>
                    <div className='filed-label'>{translatedMessage('generic.nameRo')}</div>
                    <div className='filed-value'>{competition?.name}</div>
                </div>
                <div className='col-12 md:col-6'>
                    <div className='filed-label'>{translatedMessage('generic.status')}</div>
                    <div className='filed-value'>
                        <span className={`pill status status-competition-${competition?.status.toLowerCase()}`}>
                            {CompetitionUtils.getCompetitionStatus(competition)}
                        </span>
                    </div>
                </div>
                {competition?.positionType &&
                    <div className='col-12'>
                        <div className='filed-label'>{translatedMessage('competition.positionType')}</div>
                        <div className='filed-value'>{translatedMessage("PositionType." + competition?.positionType)}</div>
                    </div>
                }
                {CompetitionUtils.isJobCompetition(competition?.type) && competition?.positionCategory &&
                    <div className='col-12'>
                        <div className='filed-label'>{translatedMessage('competition.positionCategory')}</div>
                        <div className='filed-value'>{translatedMessage("PositionCategory." + competition?.positionCategory)}</div>
                    </div>
                }
                <div className='col-12'>
                    <div className='filed-label'>{translatedMessage('competition.institution')}</div>
                    <div className='filed-value'>{competition?.institution?.name ? competition?.institution.name : "-"}</div>
                </div>
                <div className='col-12 md:col-6'>
                    <div className='filed-label'>{translatedMessage('competition.startDate')}</div>
                    <div className='filed-value'>{GeneralUtils.formatDate(competition?.startDate)}</div>
                </div>
                <div className='col-12 md:col-6'>
                    <div className='filed-label'>{translatedMessage('competition.submitEndDate')}</div>
                    <div className='filed-value'>{GeneralUtils.formatDate(competition?.submitEndDate)}</div>
                </div>
                <div className='col-12 md:col-6'>
                    <div className='filed-label'>{translatedMessage('competition.clarificationInterval')}</div>
                    <div className='filed-value'>{competition?.clarificationInterval} {translatedMessage("generic.days")}</div>
                </div>
                <div className='col-12 md:col-6'>
                    <div className='filed-label'>{translatedMessage('competition.contestationInterval')}</div>
                    <div className='filed-value'>{competition?.contestationInterval} {translatedMessage("generic.days")}</div>
                </div>
                <div className='col-12'>
                    <div className='filed-label'>{translatedMessage('generic.description')}</div>
                    <div className='filed-value'>
                        {competition?.description
                            ? <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(competition?.description) }} />
                            : "-"
                        }
                    </div>
                </div>
            </div>

            {editDialogVisible &&
                <CompetitionEditDialog
                    value={competition}
                    visible={editDialogVisible}
                    afterSave={afterSave}
                    visibleSetter={() => setEditDialogVisible(false)}
                    statuses={competitionStatuses}
                    // types={competitionTypes}
                />
            }
        </>
    );
};

export default CompetitionNationalViewComponent;
